import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const fetchMaintenanceData = createAsyncThunk(
    'maintenance/fetchMaintenanceData',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getMaintenanceData(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch maintenance data');
        }
    }
);

const initialState = {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
};

const maintenanceSlice = createSlice({
    name: 'maintenance',
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMaintenanceData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMaintenanceData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload?.data?.results || [];
                state.meta = action.payload?.data?.meta || {};
                state.error = null;
            })
            .addCase(fetchMaintenanceData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.data = [];
            });
    },
});

export const { setCurrentPage, clearError } = maintenanceSlice.actions;

export default maintenanceSlice.reducer;
